import { LocaleCode, locales } from '@/i18n/locales';

export const LANGUAGE_NAME: Record<LocaleCode, string> = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
} as const;

export const LANGUAGES = locales.map((l) => ({ value: l, labelKey: l }));

export const LANGUAGES_NAMES = locales.map((l) => ({ value: l, name: LANGUAGE_NAME[l] }));

export type LanguageCode = LocaleCode;
